<template lang="pug">
  v-dialog(v-model="show"  fullscreen scrollable)
    v-card.fill-height(flat )
      v-card-title {{selectedFoodName}}
      v-card-text(v-if="$vuetify.breakpoint.mdAndUp" )
        v-carousel(v-model="image" height="100%" :show-arrows="isShowArrows"
          hide-delimiters
          prev-icon="fas fa-arrow-left"
          next-icon="fas fa-arrow-right")
          v-carousel-item(v-for="(item,idx) in foodImageList" :key="idx"  )
            v-img(:src="getImage(item)" contain height="100%")
              template( v-slot:placeholder)
                v-row.ma-0(class="fill-height ma-0" align="center" justify="center")
                  v-progress-circular(indeterminate color="primary")
      v-card-text.pb-0(v-else style="height: 100vh;")
        v-carousel.justify-space-around(v-model="image" height="100%"
          hide-delimiters
          prev-icon="fas fa-arrow-left"
          next-icon="fas fa-arrow-right")
          v-carousel-item(v-for="(item,idx) in foodImageList" :key="idx"  )
            v-img(:src="getImage(item)" contain height="100%")
              template( v-slot:placeholder)
                v-row.ma-0(class="fill-height ma-0" align="center" justify="center")
                  v-progress-circular(indeterminate color="primary")
      v-card-actions
        v-spacer
        v-btn( text color="primary"  @click="onCloseButtonClick") {{ $t('buttons.closeButtonLabel') }}


</template>

<script lang="ts">

import {Component, Prop} from "vue-property-decorator";
import Vue from 'vue';
import FoodImageModel from "@/model/FoodImageModel";

@Component({})

export default class DetailImageDialog extends Vue {

  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({type: Array as () => FoodImageModel[] | null}) foodImageList!: FoodImageModel[]
  @Prop({type: String , default: false }) selectedFoodName!: string
  @Prop({ type: Number, default: false }) readonly index!: null
  @Prop({type: Object as () => any}) selectedFood!: any



  private image: number | null = this.index

  get isShowArrows (): boolean {
      if(this.foodImageList && this.foodImageList.length > 1) {
          return true
      } else {
          return false
      }
  }

  getImage (item: any) {
      return `/api/food-database/food-item-media/${item.id}/data`
  }

  onCloseButtonClick (): void {
    this.$emit('close')
  }

  mounted() {
  }

}

</script>

<style lang="stylus" scoped>


</style>
